module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-sidebar-wrapper"
  }, [_c('div', {
    staticClass: "page-sidebar navbar-collapse collapse"
  }, [_c('ul', {
    staticClass: "page-sidebar-menu page-header-fixed page-sidebar-menu-hover-submenu page-sidebar-menu-closed",
    attrs: {
      "data-keep-expanded": "false",
      "data-auto-scroll": "true",
      "data-slide-speed": "200"
    }
  }, [_c('router-link', {
    staticClass: "nav-item start",
    attrs: {
      "to": "/admin/dashboard",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link active"
  }, [_c('i', {
    staticClass: "icon-home activ"
  }), _vm._v(" "), _c('span', {
    staticClass: "selected"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Home")])])]), _vm._v(" "), (_vm.user.organizations.length > 1 || _vm.user.access > 4) ? _c('li', {
    staticClass: "nav-item",
    class: _vm.activeChild()
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user.organizations.length > 1 || _vm.user.access > 5) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'View As'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("View As")])])]) : _vm._e(), _vm._v(" "), (_vm.user.access > 5) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Manage Account List'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Manage Accounts")])])]) : _vm._e(), _vm._v(" "), (_vm.user.access > 4) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Manage Users'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Manage Users")])])]) : _vm._e(), _vm._v(" "), (_vm.user.access > 4) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Form Builder Index'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Form Builder")])])]) : _vm._e(), _vm._v(" "), (_vm.user.access > 4) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Imports Select'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Data Import")])])]) : _vm._e(), _vm._v(" "), (_vm.user.access > 5) ? _c('li', {
    staticClass: "nav-item"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user.access > 5) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'General Settings'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Maintenance Mode")])])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user.access > 4) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Email Settings'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Email Settings")])])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user.access > 1) ? _c('li', {
    staticClass: "nav-item",
    class: _vm.activeChildDirectory()
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Participant Directory'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.participantSingularName) + " Directory")])])]), _vm._v(" "), (_vm.user.access > 2) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": _vm.showAddUserModal
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('span', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Add New " + _vm._s(_vm.participantSingularName))])])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user.access > 1) ? _c('li', {
    staticClass: "nav-item",
    class: _vm.activeChildWorkspace()
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user.access > 2) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Workspace'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Organization Forms")])])]) : _vm._e(), _vm._v(" "), (_vm.user.access > 2) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Shared files'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Shared Files")])])]) : _vm._e(), _vm._v(" "), (_vm.user.access > 5) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Public files'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Public Files")])])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user.access > 2) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Reports Index',
        params: {
          'reset': true
        }
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Reports")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu hide"
  })]) : _vm._e(), _vm._v(" "), (_vm.user.access > 1) ? _c('li', {
    staticClass: "nav-item",
    class: _vm.activeGroups()
  }, [_vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Groups Forms'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Activities and Services")])])]), _vm._v(" "), (_vm.user.access > 1 && _vm.user.twilioStatus) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Messaging Home'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Messaging")])])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user.access >= 3) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Referral Dashboard'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle"
  }, [_c('i', {
    staticClass: "icon-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Referral/Application Dashboard")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  })]) : _vm._e(), _vm._v(" "), (_vm.user.access > 2) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Calendar'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle"
  }, [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Scheduling")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  })]) : _vm._e(), _vm._v(" "), (_vm.showLink && _vm.user.access > 1 && _vm.user.twilioStatus) ? _c('router-link', {
    staticClass: "nav-item",
    class: _vm.activeMessages(),
    attrs: {
      "to": {
        name: 'Messages',
        params: {
          id: _vm.$route.params.id
        }
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle"
  }, [_c('i', {
    staticClass: "icon-bubbles"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Messaging")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])]) : _vm._e(), _vm._v(" "), (_vm.showLink && _vm.user.access > 1) ? _c('router-link', {
    staticClass: "nav-item",
    class: _vm.activeActivities(),
    attrs: {
      "to": {
        name: 'Activities and Services',
        params: {
          id: _vm.$route.params.id
        }
      },
      "tag": "li",
      "active-class": "active"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitCancel.apply(null, arguments)
      }
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle"
  }, [_c('i', {
    staticClass: "icon-puzzle"
  }), _vm._v(" "), _c('span', {
    staticClass: "selected"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Activities & Services")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])]) : _vm._e(), _vm._v(" "), (_vm.showLink && _vm.user.access > 1) ? _c('router-link', {
    staticClass: "nav-item",
    class: _vm.activeAssessments(),
    attrs: {
      "to": {
        name: 'Assessment and Outcomes',
        params: {
          id: _vm.$route.params.id
        }
      },
      "tag": "li",
      "active-class": "active"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitCancel.apply(null, arguments)
      }
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle"
  }, [_c('i', {
    staticClass: "icon-folder"
  }), _vm._v(" "), _c('span', {
    staticClass: "selected"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Assessments & Outcomes")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])]) : _vm._e(), _vm._v(" "), (_vm.user.access > 1) ? _c('li', {
    staticClass: "nav-item",
    class: _vm.activeSupport()
  }, [_vm._m(5), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Contact'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Contact")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'FAQ'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("FAQ")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Help and Tutorials'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Help and Tutorials")])])])], 1)]) : _vm._e()], 1)]), _vm._v(" "), _c('add-user-search-modal', {
    attrs: {
      "refresh": _vm.refreshAddUserModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-settings"
  }), _vm._v(" "), _c('span', {
    staticClass: "selected"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Administrative Settings")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("General Settings "), _c('i', {
    staticClass: "pull-right fa fa-chevron-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Directory")]), _vm._v(" "), _c('span', {
    staticClass: "selected"
  }), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-share"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Workspace")]), _vm._v(" "), _c('span', {
    staticClass: "selected"
  }), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-docs"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Groups")]), _vm._v(" "), _c('span', {
    staticClass: "selected"
  }), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-question"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Support")]), _vm._v(" "), _c('span', {
    staticClass: "selected"
  }), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48c5f97b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/Sidebar.vue
// module id = 1630
// module chunks = 1